module.exports = __webpack_public_path__ + "img/232.4fc2042.svg";